import React, { useMemo } from 'react';
import { Select } from 'antd';
import { GlobalVariable, DropdownSettings } from '@kemu-io/kemu-core/common/managers/globalVariables.js';
import { DataType, SupportedTypes } from '@kemu-io/hs-types';
import styles from '../GlobalVariablesPanel.module.css';

type Props = {
  variable: GlobalVariable;
  onChange: (name: string,value: SupportedTypes, type: DataType) => void;
}

/**
 * Dropdown control component for global variables
 * @param variable - The global variable configuration
 * @param onChange - Callback when value changes
 */
const DropdownControl = ({ variable, onChange }: Props) => {
  const settings = variable.controlSettings as DropdownSettings;
  const currentValue = variable.lastValue as string ?? '';

  const handleChange = (value: string) => {
    onChange(variable.name, value, DataType.String);
  };

  const options = useMemo(() => settings.options.map(option => ({
    label: option,
    value: option,
  })), [settings.options]);

  return (
    <Select
      value={currentValue}
      onChange={handleChange}
      options={options}
      placeholder="Select option"
      className={styles.ControlSelect}
      rootClassName={styles.DropdownSelectRoot}
      style={{ width: '100%' }}
    />
  );
};

export default DropdownControl;
